export default __webpack_public_path__ + "static/media/astronaut_reading.7c6f6d94.png";